/* eslint-disable react/style-prop-object */
import React from 'react';
import { Button, DialogTrigger, Flex, Text, View } from '@adobe/react-spectrum';
import { DownloadDialog } from 'app/views/components/dialogs/DownloadDialog';
import { analytics } from 'app/utils/analytics';
export const Download = (props) => {
    const { onSelect } = props;
    return (React.createElement(View, { padding: "size-150", borderColor: "gray-200", borderWidth: "thin", borderRadius: "medium", gridArea: "left" },
        React.createElement(Flex, { direction: "column", gap: "size-150" },
            React.createElement(Text, null, "Directly download image from the web "),
            React.createElement(DialogTrigger, { type: "modal", onOpenChange: isOpen => analytics({
                    action: 'LoadImage',
                    label: isOpen ? 'openUrlDialog' : 'closeUrlDialog',
                }) },
                React.createElement(Button, { variant: "secondary", style: "outline" }, "Download image"),
                close => (React.createElement(DownloadDialog, { onDownload: onSelect, close: close }))))));
};
